/* eslint-disable */

// TODO: move all scripts to index.html
const {
  REACT_APP_AMPLITUDE_ID,
  REACT_APP_FACEBOOK_PIXEL_ID,
  REACT_APP_TAPFILIATE_ID,
} = process.env;

const loadScript = url => {
  return new Promise(resolve => {
    const script = document.createElement('script');
    script.onload = params => resolve(script, params);
    script.src = url;
    document.getElementsByTagName('head')[0].appendChild(script);
  });
};

// AMPLITUDE
if (REACT_APP_AMPLITUDE_ID) {
  (function (e, t) {
    var n = e.amplitude || { _q: [], _iq: {} };
    var r = t.createElement("script")
    ;r.type = "text/javascript";
    r.async = true
    ;r.src = "https://cdn.amplitude.com/libs/amplitude-4.4.0-min.gz.js"
    ;r.onload = function () {
      if (e.amplitude.runQueuedFunctions) {
        e.amplitude.runQueuedFunctions()
      } else {
        console.log("[Amplitude] Error: could not load SDK")
      }
    }
    ;var i = t.getElementsByTagName("script")[0];
    i.parentNode.appendChild(r);

    function s(e, t) {
      e.prototype[t] = function () {
        this._q.push([t].concat(Array.prototype.slice.call(arguments, 0)));
        return this
      }
    }

    var o = function () {
        this._q = [];
        return this
      }
    ;var a = ["add", "append", "clearAll", "prepend", "set", "setOnce", "unset"]
    ;
    for (var u = 0; u < a.length; u++) {
      s(o, a[u])
    }
    n.Identify = o;
    var c = function () {
        this._q = []
        ;
        return this
      }
    ;var l = ["setProductId", "setQuantity", "setPrice", "setRevenueType", "setEventProperties"]
    ;
    for (var p = 0; p < l.length; p++) {
      s(c, l[p])
    }
    n.Revenue = c
    ;var d = ["init", "logEvent", "logRevenue", "setUserId", "setUserProperties", "setOptOut", "setVersionName", "setDomain", "setDeviceId", "setGlobalUserProperties", "identify", "clearUserProperties", "setGroup", "logRevenueV2", "regenerateDeviceId", "logEventWithTimestamp", "logEventWithGroups", "setSessionId", "resetSessionId"]
    ;

    function v(e) {
      function t(t) {
        e[t] = function () {
          e._q.push([t].concat(Array.prototype.slice.call(arguments, 0)))
        }
      }

      for (var n = 0; n < d.length; n++) {
        t(d[n])
      }
    }

    v(n);
    n.getInstance = function (e) {
      e = (!e || e.length === 0 ? "$default_instance" : e).toLowerCase()
      ;
      if (!n._iq.hasOwnProperty(e)) {
        n._iq[e] = { _q: [] };
        v(n._iq[e])
      }
      return n._iq[e]
    }
    ;e.amplitude = n
  })(window, document);
  amplitude.getInstance().init(REACT_APP_AMPLITUDE_ID);
}

// Facebook Pixel
if (REACT_APP_FACEBOOK_PIXEL_ID) {
  !function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ?
        n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.appendChild(t);
  }(window, document, 'script',
    'https://connect.facebook.net/en_US/fbevents.js');
  fbq('init', REACT_APP_FACEBOOK_PIXEL_ID);
  fbq('track', 'PageView');
}

// Tapfiliate
if (REACT_APP_TAPFILIATE_ID) {
  loadScript('https://script.tapfiliate.com/tapfiliate.js')
    .then(() => {
      (function (t, a, p) {
        t.TapfiliateObject = a;
        t[a] = t[a] || function () {
          (t[a].q = t[a].q || []).push(arguments)
        }
      })(window, 'tap');
      tap('create', REACT_APP_TAPFILIATE_ID, { integration: "javascript" });
      tap('detect');
    });
}
